import React from 'react'
import { TooltipProps } from './types'
interface TooltipState {
  tooltipList: TooltipProps[]
  addTooltip: (props: TooltipProps) => void
  removeTooltip: (id?: string) => void
}

export const TooltipContext = React.createContext<TooltipState>({
  tooltipList: [],
  addTooltip: () => {},
  removeTooltip: () => {},
})
